import { Link } from "react-router-dom";
import { DriveItem, FileActionsConfig } from "../types";

interface FileActionsMenuProps {
  item: DriveItem;
  /** Controls spacing/styling so the menu matches its surrounding (table row vs grid card). */
  layout: "list" | "grid";
  actions: FileActionsConfig;
}

/**
 * The "⋮" dropdown shown on every file row/card.
 *
 * `variant: "full"` exposes Rename / Delete / Download / Share / Share Info /
 * Copy Link (owned files); `variant: "readonly"` exposes only Download /
 * Copy Link. File-only actions are hidden for folders.
 */
const FileActionsMenu = ({ item, layout, actions }: FileActionsMenuProps) => {
  const isGrid = layout === "grid";
  const itemClass = isGrid ? "dropdown-item rounded-1" : "dropdown-item";
  const iconMargin = isGrid ? "me-1" : "me-2";
  const menuClass = isGrid
    ? "dropdown-menu dropdown-menu-end p-2"
    : "dropdown-menu dropdown-menu-end";
  const triggerClass = isGrid
    ? "d-inline-flex align-items-center"
    : "text-muted p-2 d-inline-flex align-items-center justify-center";

  const isFile = item.type !== 1;
  const isFull = actions.variant === "full";

  return (
    <div className="dropdown" style={isGrid ? { flexShrink: 0 } : undefined}>
      <Link
        to="#"
        className={triggerClass}
        data-bs-toggle="dropdown"
        id={`dropdown-${item.id}`}
      >
        <i className="fas fa-ellipsis-v" />
      </Link>
      <ul className={menuClass}>
        {isFull && (
          <>
            <li>
              <Link
                to="#"
                className={itemClass}
                onClick={() => actions.onRename?.(item)}
              >
                <i className={`ti ti-edit ${iconMargin}`} /> Rename
              </Link>
            </li>
            <li>
              <Link
                to="#"
                data-bs-toggle="modal"
                data-inert={true}
                data-bs-target="#delete_file_modal"
                className={itemClass}
                onClick={() => actions.onDelete?.(item)}
              >
                <i className={`ti ti-trash ${iconMargin}`} /> Delete
              </Link>
            </li>
          </>
        )}
        {isFile && (
          <>
            <li>
              <Link
                to="#"
                className={itemClass}
                onClick={() => actions.onDownload(item)}
              >
                <i className={`ti ti-download ${iconMargin}`} /> Download
              </Link>
            </li>
            {isFull && (
              <>
                <li>
                  <Link
                    to="#"
                    className={itemClass}
                    onClick={() => actions.onShare?.(item)}
                  >
                    <i className={`ti ti-share ${iconMargin}`} /> Share
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className={itemClass}
                    onClick={() => actions.onShareInfo?.(item)}
                  >
                    <i className={`ti ti-info-circle ${iconMargin}`} /> Share Info
                  </Link>
                </li>
              </>
            )}
            <li>
              <Link
                to="#"
                className={itemClass}
                onClick={() => actions.onCopyLink(item)}
              >
                <i className={`ti ti-link ${iconMargin}`} /> Copy Link
              </Link>
            </li>
          </>
        )}
      </ul>
    </div>
  );
};

export default FileActionsMenu;
